module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-Regular-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-Regular-webfont.woff
// module id = 354
// module chunks = 0